import { CohortEnum } from '@eigtech/auth0-types'
import type { DocumentSource } from '@eigtech/documents-types'
import { exhaustive } from 'exhaustive'

export const canEditDocument = (source: DocumentSource, cohort: CohortEnum) =>
  exhaustive(source, {
    CSR: () => false,
    Estimator: () => cohort === 'estimator',
    Meetings: () => false,
    Technician: () => cohort === 'technician',
    TPLAP: () => cohort === 'insured' || cohort === 'technician',
    Verisk: () => false,
    Symbility: () => false,
    Documator: () => false,
    Invoicing: () => false,
    Inspections: () => false,
  })
